import { Link } from 'react-router'

const recordCategories = [
	{
		title: 'Genealogy Index',
		description:
			'Search our index of over 92,000 genealogy records for family surnames.',
		to: '/records/genealogy',
	},
	{
		title: 'Deed Transfers',
		description:
			'Search our index of deed transfer records with links to scanned PDF copies.',
		to: '/records/deeds',
	},
	{
		title: 'Genealogy Research',
		description:
			'Learn about our genealogy department, research services, and how to schedule a visit.',
		to: '/records/genealogy-research',
	},
]

export default function RecordsIndex() {
	return (
		<div className="px-4 pb-8 pt-4">
			<div className="mx-auto max-w-6xl sm:px-6 lg:px-8">
				<header className="py-5">
					<h1 className="text-3xl font-bold leading-tight text-gray-900">
						Records
					</h1>
					<p className="mt-2 text-lg text-gray-600">
						Browse our collection of historical records.
					</p>
				</header>
				<div className="grid grid-cols-1 gap-6 md:grid-cols-2">
					{recordCategories.map((category) => (
						<Link
							key={category.title}
							to={category.to}
							className="block rounded-lg bg-white p-6 shadow transition hover:shadow-md"
						>
							<h3 className="text-2xl font-semibold uppercase tracking-wide text-ebhs-blue">
								{category.title}
							</h3>
							<p className="mt-2 text-gray-600">{category.description}</p>
						</Link>
					))}
				</div>
			</div>
		</div>
	)
}
